import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Compact navy banner at the top of every inner page.
function PageHero({ title, subtitle, crumb }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-brand-navy via-brand-navy to-brand-navy-dark text-white">
      <div
        className="absolute inset-0 opacity-[0.07]"
        aria-hidden="true"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #fff 0, #fff 1px, transparent 1px, transparent 14px)",
        }}
      />
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-brand-yellow/20 blur-3xl" aria-hidden="true" />

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16"
      >
        <nav aria-label="Breadcrumb" className="text-sm text-blue-100">
          <ol className="flex items-center gap-2">
            <li>
              <Link to="/" className="inline-block py-1.5 hover:text-brand-yellow transition-colors">
                Home
              </Link>
            </li>
            <li aria-hidden="true">/</li>
            <li aria-current="page" className="font-semibold text-brand-yellow">
              {crumb || title}
            </li>
          </ol>
        </nav>
        <h1 className="mt-3 font-display text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">{title}</h1>
        <div className="mt-4 h-1 w-16 rounded-full bg-brand-yellow" />
        {subtitle && <p className="mt-4 max-w-2xl text-base sm:text-lg text-blue-100">{subtitle}</p>}
      </motion.div>
    </section>
  );
}

export default PageHero;
